var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prt-expense-summary",class:{cwb: _vm.cwb}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"amount",class:{positive: _vm.amount >= 0}},[_vm._v(_vm._s(_vm.amountWithCurrency))])])
}
var staticRenderFns = []

export { render, staticRenderFns }